import { format } from 'date-fns';

const url = process.env.REACT_APP_STORAGE_URL;

if (!url)
    throw new Error('The REACT_APP_STORAGE_URL environment variable was not configured!');

const getFormattedCurrentDateTime = () => format(new Date(), 'yyyyMMddHHmm');  

const getTemplateUrl = (uuid: string, name: string) =>
    `${url}/complimentary-template/${uuid}/${name}?${getFormattedCurrentDateTime()}`;

const getExhibitorLogo = (uuid: string) =>
    `${url}/vehicle/logo/${uuid.replaceAll('-', '')}?${getFormattedCurrentDateTime()}`;

const getExhibitorIcon = (uuid: string) =>
    `${url}/vehicle/icon/${uuid.replaceAll('-', '')}?${getFormattedCurrentDateTime()}`;

const getSystemLogo = () => {
    const { protocol, host } = window.location;
    const baseUrl = `${protocol}//${host}`;
    return `${baseUrl}/logo192_2.png`;
};

export { getTemplateUrl, getExhibitorLogo, getExhibitorIcon, getSystemLogo };